<iframe #frame src="https://storage.googleapis.com/fpx-poc/visualizer.html" width="100%" height="500px" frameborder="0"
        (load)="frameLoaded()"></iframe>
